import { PureComponent } from 'react'

export default class MarkerPositionIndicator extends PureComponent {
  render() {
    const { x, y, height } = this.props
    const colorScheme = this.context
    const color = colorScheme.highlight
    const transformString = `translate(${Math.round(x)}px, ${Math.round(y)}px)`
    const style = {
      left: 0,
      top: 0,
      WebkitTransform: transformString,
      MozTransform: transformString,
      msTransform: transformString,
      transform: transformString,
      zIndex: 15,
    }
    const lineStyle = {
      height: height,
      borderLeftColor: color,
    }
    const dotRadius = 4
    const dotSize = dotRadius * 2
    const dotStyle = {
      width: dotSize,
      height: dotSize,
      borderRadius: dotRadius,
      marginLeft: -dotRadius,
      marginTop: -dotRadius,
      backgroundColor: color,
    }
    return (
      <span className="marker-position-indicator" style={style}>
        <div className="marker-position-indicator__line" style={lineStyle}></div>
        <div className="marker-position-indicator__dot" style={dotStyle}></div>
      </span>
    )
  }
}
